import { IsInt, IsUUID, Min } from 'class-validator';

export class ChatMessageCursor {
    @IsInt()
    @Min(0)
    public readonly timestamp: number;

    @IsUUID()
    public readonly uuid: string;

    constructor(data: Partial<ChatMessageCursor>) {
        this.timestamp = data.timestamp;
        this.uuid = data.uuid;
    }
}
